export const es_37 = {
    send_balance: {
        "mobile_number_placeholder": "Número de celular",
        "enter_mobile_number": "Por favor ingresa el número de celular",
        "topup_sub_heading": "Ingresa el número al que te gustaría agregar saldo",
        "select_amt_label" : "Selecciona el monto de recarga",
        "topup_heading":"Envía Recargas",
        "select_country": "Selecciona el país de Latinoamérica",
    },
    receipt: {
        "recipient": "Número Celular",
        "supportTickets": "Ticket de soporte",
        'net_charge': "Cargo total",
    },
    validations: {
        'mobile_number_required': "Se requiere número celular",
    },
    auto_balance: {
        "cancel_message": "¿Seguro que quieres cancelar la recarga automática a número celular + {{internationalCode}} {{localMobileNumber}}?",
        "no_profile_msg": "No hay recarga automática activa disponible. Haz clic en el botón de abajo para crear un nuevo perfil.",
    },
    menu: {
        "support_tickets": "Ticket de soporte",
        "send_balance": "Envía Recargas"
    },
    common: {
        "plan" : "Paquetes",
    },
    myaccount: {
        "no_ticket": "No tienes ningún ticket de soporte."
    }
}